<template>
  <div>
    <span
      :key="category.category"
      v-for="(category, index) in categories"
      v-if="categories"
    >
      <router-link
        class="category text-capitalize"
        :class="variant"
        :target="newWindow ? '_blank' : null"
        :to="`/gallery/${category.category}/`"
        v-html="getName(category.category)"
      >
      </router-link>
      <span v-if="index < categories.length - 1">, </span>
    </span>
    <div v-if="!categories || !categories.length">
      &nbsp;
    </div>
  </div>
</template>

<script>
export default {
  props: {
    categories: {
      type: Array
    },
    variant: {
      type: String
    },
    newWindow: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    getName(c) {
      return window.categories.find(({ category }) => category === c).name;
    }
  }
};
</script>

<style lang="scss" scoped>
.category {
  color: rgb(72, 72, 72);
  &.dark {
    color: white;
  }

  &:hover {
    text-decoration: underline;
  }
}
</style>
